import { useEffect, useState } from 'react';
import { useRouter } from 'next/navigation';
import { Market } from 'components/commercetools-ui/organisms/header/types';
import i18nConfig from 'i18n.config';
import { getLocalizationInfo } from 'project.config';
import usePath from './usePath';
import useLocale from './useLocale';

const useMarket = () => {
  const [markets, setMarkets] = useState<Market[]>([]);
  const [market, setMarket] = useState<Market>();
  const router = useRouter();

  const { path } = usePath();

  const { ctLocale: locale } = useLocale();

  const handleMarket = (market: Market) => {
    setMarket(market);
  };

  useEffect(() => {
    const initialMarkets = i18nConfig.locales.map((nextLocale) => {
      const { locale, currency, currencyCode, countryCode, countryName } = getLocalizationInfo(nextLocale);

      return {
        locale,
        currencyCode,
        region: countryName,
        flag: countryCode,
        currency: currency,
      };
    });

    if (!initialMarkets) return;

    setMarkets(initialMarkets);

    let initialMarket = initialMarkets.find((market) => market.locale.substring(0, 2) === locale);
    if (!initialMarket) {
      initialMarket = initialMarkets.find((market) => market.locale.substring(0, 2) === i18nConfig.defaultLocale);
    }

    setMarket(initialMarket);
  }, [locale]);

  return { market, markets, handleMarket };
};

export default useMarket;
